import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { ICreateOfferToSubDealerRequest, ICreateOfferToSubDealerResponse } from '../models/models'

export class SaveOfferToSubDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'offer/saveOffer',
      requesterInfo,
    })
  }

  public async saveOffer(request: ICreateOfferToSubDealerRequest): Promise<ICreateOfferToSubDealerResponse> {
    return await this.postAsync<ICreateOfferToSubDealerResponse>(request)
  }
}
